<div class="action-buttons">
  <app-column-picker
    [treeNodes]="treeNodes"
    [preselectedColumnKey]="selectedColumnKey"
    [allowReset]="true"
    [type]="tab!.type"
    (selectedColumnKey)="onColumnSelect($event)"></app-column-picker>
  <mat-form-field>
    <span matIconSuffix class="search-icons">
      @if (searchControl.value) {
        <mat-icon (click)="clearSearch()" style="cursor: pointer">close</mat-icon>
      }
      <mat-icon (click)="search()" style="cursor: pointer">search</mat-icon>
    </span>
    <input matInput placeholder="Search in the table" [formControl]="searchControl" (keydown.enter)="search()" />
  </mat-form-field>
  <button mat-icon-button (click)="clearFilters()">
    <span class="material-symbols-outlined">filter_alt_off</span>
  </button>
  <button mat-stroked-button [disabled]="tab?.predefined" (click)="shareView()">
    Share view
    <mat-icon>share</mat-icon>
  </button>
  @if (tab?.type === 'Shipments' || tab?.type === 'Containers') {
    <button mat-stroked-button [disabled]="!selectedItems.length" (click)="editCustomFields()">
      Edit custom fields
      <mat-icon>tune</mat-icon>
    </button>
  }
  <app-excel-export [selectedItems]="selectedItems" [tab]="tab"></app-excel-export>

  <button mat-stroked-button (click)="configureTab()" [disabled]="tab?.predefined">
    Configure tab
    <mat-icon>settings</mat-icon>
  </button>
</div>
